<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <organizations-documents-page />
    </div>
  </div>
</template>

  <script>
  import OrganizationDocumentsPage from '../Components/OrganizationDocumentsPage.vue';
    export default {
      name: 'Documents',
      components: {
        'organizations-documents-page': OrganizationDocumentsPage,
      },
    };
  </script>
